import {
  CalendarToday,
  LocationSearching,
  MailOutline,
  PhoneAndroid,
  Publish,
} from "@material-ui/icons"
import "./user.css"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useState } from "react"
import { serverAPI } from "../../services/apiParams"
import { getUsers } from "../../redux/apiCalls"
import Checkbox from "@mui/material/Checkbox"
import { onImageUpload } from "../../services/uploadImage"
import { renderErrorMsg } from "../../services/errorsForm"

export default function User() {
  const [userForm, setUserForm] = useState()
  const location = useLocation()
  const userId = location.pathname.split("/")[2]
  const dispatch = useDispatch()
  const user = useSelector((store) => {
    return store.user.users.find((user) => {
      return String(user.id) === userId
    })
  })
  const [isAdmin, setIsAdmin] = useState(user.is_admin)
  //user date created_at
  const user_date = new Date(user.created_at).toISOString().split("T")[0]

  const [formErrorMsg, setFormErrorMsg] = useState()

  //image upload
  const [imageUrl, setImageUrl] = useState()
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false)

  //update a user  information
  const handleChangeForm = (e) => {
    setUserForm({
      ...userForm,
      [e.target.name]: e.target.value,
    })
  }
  const handleChangeImage = (e) => {
    onImageUpload(e, setSubmitBtnDisabled, setFormErrorMsg, setImageUrl)
  }
  const adminCheckChange = () => {
    setIsAdmin((prev) => (prev === 1 ? 0 : 1))

    setUserForm({
      ...userForm,
      is_admin: isAdmin,
    })
  }
  const onEditUser = async (e) => {
    e.preventDefault()
    const newUser = { ...userForm, image: imageUrl }

    try {
      await serverAPI.post(`api/users/${userId}`, newUser)
      //reset form
      setUserForm(undefined)
      // update Store.users after editing the user's data
      getUsers(dispatch)
      //reset form's inputs after submit
      document.getElementById("editUserForm").reset()
    } catch (error) {
      console.log(error.response)
      setFormErrorMsg(error.response.data?.errors)
    }
  }
  return (
    <div className='user'>
      <div className='userTitleContainer'>
        <h1 className='userTitle'>Edit User</h1>
      </div>
      <div className='userContainer'>
        <div className='userShow'>
          <div className='userShowTop'>
            <img src={user.image} alt='' className='userShowImg' />
            <div className='userShowTopTitle'>
              <span className='userShowUsername'>
                {user.first_name} {user.last_name}
              </span>
            </div>
          </div>
          <div className='userShowBottom'>
            <span className='userShowTitle'>Account Details</span>
            <div className='userShowInfo'>
              <CalendarToday className='userShowIcon' />
              <span className='userShowInfoTitle'>{user_date}</span>
            </div>
            <span className='userShowTitle'>Contact Details</span>
            <div className='userShowInfo'>
              <PhoneAndroid className='userShowIcon' />
              <span className='userShowInfoTitle'>{user.phone}</span>
            </div>
            <div className='userShowInfo'>
              <MailOutline className='userShowIcon' />
              <span className='userShowInfoTitle'>{user.email}</span>
            </div>
            <div className='userShowInfo'>
              <LocationSearching className='userShowIcon' />
              <span className='userShowInfoTitle'>{user.address}</span>
            </div>
          </div>
        </div>
        <div className='userUpdate'>
          <span className='userUpdateTitle'>Edit</span>
          <form className='userUpdateForm' id='editUserForm'>
            <div className='userUpdateLeft'>
              <div className='userUpdateItem'>
                <label>First Name</label>
                <input
                  type='text'
                  name='first_name'
                  placeholder={user.first_name}
                  className='userUpdateInput'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "first_name")}
              </div>
              <div className='userUpdateItem'>
                <label>Last Name</label>
                <input
                  type='text'
                  name='last_name'
                  placeholder={user.last_name}
                  className='userUpdateInput'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "last_name")}
              </div>
              <div className='userUpdateItem'>
                <label>Email</label>
                <input
                  type='text'
                  name='email'
                  placeholder={user.email}
                  className='userUpdateInput'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "email")}
              </div>
              <div className='userUpdateItem'>
                <label>Phone</label>
                <input
                  type='text'
                  name='phone'
                  placeholder={user.phone}
                  className='userUpdateInput'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "phone")}
              </div>
              <div className='userUpdateItem'>
                <label>Address</label>
                <input
                  type='text'
                  name='address'
                  placeholder={user.address}
                  className='userUpdateInput'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "address")}
              </div>
            </div>
            <div className='userUpdateRight'>
              <div className='userUpdateUpload'>
                <img className='userUpdateImg' src={user.image} alt='' />
                <label htmlFor='file'>
                  <Publish className='userUpdateIcon' />
                </label>
                <input
                  type='file'
                  id='file'
                  style={{ display: "none" }}
                  onChange={handleChangeImage}
                />
                {renderErrorMsg(formErrorMsg, "image")}
              </div>
              <div className='userUpdateItem'>
                <label style={{ textAlign: "center" }}>Is admin</label>
                <Checkbox
                  onChange={adminCheckChange}
                  checked={isAdmin ? true : false}
                />
              </div>
              <button
                className='userUpdateButton'
                onClick={onEditUser}
                disabled={submitBtnDisabled}>
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
